import axios from 'axios'
import {Toast} from "vant";
import Bridge from "@/utils/bridgeAsync.js";
// 测试环境
// export const baseURL = 'https://pay-test.eye4.cn';
// 正式环境
export const baseURL = 'https://order-api.eye4.cn';

const bridge = new Bridge()
let uid: string, authkey: string
bridge.init()
    .then(() => {
        const data = bridge.userInfo()
        uid = data.uid
        authkey = data.authkey
    })
    .catch(() => {
        console.warn('entry的bridge初始化失败')
    })

/**
 * axios请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf = (config: any) => {
    config.headers['uid'] = uid || '12218045'
    config.headers['authkey'] = authkey || 's+9nPELJoZFCrQfAhgYorshUc0TAcZXuVLYwa0e6BPHUgb903MKcgJU7w1A4Io8W'
    return config
}



/**
 * @description axios初始化
 */
const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
})

/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(requestConf, (error) => {
    return Promise.reject(error)
})

/**
 * axios响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
const handleData = async (data: any) => {
    switch (data.status) {
        case 0:
        case 200:
            return data.data.hasOwnProperty('data') ? data.data.data : data.data
        case 404:
            Toast(data.data.msg)
            break
        default:
            return Promise.reject(data)
    }
}

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
    response => handleData(response),
    error => {
        console.log('[mglink API请求异常]', error);
        const {response} = error
        if (response === undefined) {
            return Promise.reject({})
        } else return handleData(response)
    }
)

export default instance
